import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import VanityLinkForm from './VanityLinkForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import style from './styles/style.module.css';


class EditVanityLinkModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            deleteConfirm: false,
            fetching: false,
        };
    }
    submitHandler = ( values ) => {
        this.setState( { fetching: true } );
        this.props.updateVanityLink( values.id, { ...values } )
        .then( ( vanityLink ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( vanityLink );
        } );
    }
    toggleDeleteConfirmation = ( state ) => {
        return () => {
            this.setState( { deleteConfirm: state } );
        };
    }
    deleteVanityLink = () => {
        this.setState( { fetching: true } );
        this.props.deleteVanityLink( this.props.vanityLink.id )
        .then( () => {
            this.setState( { fetching: false, deleteConfirm: false } );
            this.props.onSubmit && this.props.onSubmit( null );
        } );
    }



    render() {
        const { vanityLink } = this.props;
        var initialValues = { ...vanityLink };
        initialValues.vanity_url_path = initialValues.vanity_url_path.replace( /^\//, '' );
        return (
            <DLModal title='Edit Vanity URL'
            closeHandler={ this.props.closeModal }>
                <div>
                    <VanityLinkForm onSubmit={ this.submitHandler } initialValues={ initialValues } />
                    { this.renderDeleteSection() }
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }

    renderDeleteSection = () => {
        if( this.state.deleteConfirm ) {
            return (
                <div className={style.deleteLink}>
                    <p>ARE YOU SURE YOU WANT TO DELETE THIS VANITY URL?</p>
                    <p>
                        <span className={ style.confirmDelete }
                        onClick={ this.deleteVanityLink }>
                            DELETE VANITY URL
                        </span>
                        <span className={ style.cancelDelete }
                        onClick={ this.toggleDeleteConfirmation( false ) }>
                            CANCEL
                        </span>
                    </p>
                </div>
            );
        }
        return (
            <div className={style.deleteLink}>
                <span
                onClick={ this.toggleDeleteConfirmation( true ) }>
                    DELETE THIS VANITY URL
                </span>
            </div>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        updateVanityLink: ( id, data ) => {
            return dAPI.patch( `/admin/vanity-urls/${ id }`, data );

        },
        deleteVanityLink: ( id ) => {
            return dAPI.delete( `/admin/vanity-urls/${ id }` );

        },
    };
};

export default connect( null, mapDispatchToProps )( EditVanityLinkModal );
